<template>
    <b-modal ref="modal" size="lg" centered :title="$t('USERSFORM')" @close="close()" no-close-on-backdrop no-close-on-esc
        hide-footer>
        <div class="d-block mt-2">
            <div role="group" class="b-form-group form-group" v-if="formData != null">
                <div class="form-row mb-lg">
                    <div class="col-sm-4 mb-2">
                        <strong>{{ $t('BASICDATA') }}</strong>
                    </div>
                </div>
                <div class="form-row mb-lg">
                    <div class="col-sm-3">
                        <b-form-fieldset v-bind:label="$t('USERNAME')">
                            <inputvalidation :formerror="formError" name="username"><b-form-input type="text"
                                    v-model="formData.username" v-bind:placeholder="$t('USERNAME')"></b-form-input>
                            </inputvalidation>
                        </b-form-fieldset>
                    </div>
                    <div class="col-sm-3">
                        <b-form-fieldset v-bind:label="$t('PASSWORD')">
                            <inputvalidation :formerror="formError" name="password"><b-form-input type="password"
                                    v-model="formData.password" v-bind:placeholder="$t('PASSWORD')"></b-form-input>
                            </inputvalidation>
                        </b-form-fieldset>
                    </div>
                    <div class="col-sm-3">
                        <b-form-fieldset v-bind:label="$t('USEREMAIL')">
                            <inputvalidation :formerror="formError" name="userEmail"><b-form-input type="email"
                                    v-model="formData.userEmail" v-bind:placeholder="$t('USEREMAIL')"></b-form-input>
                            </inputvalidation>
                        </b-form-fieldset>
                    </div>
                    <div class="col-sm-3" :class="(!newuser) ? 'col-sm-12' : ''">
                        <b-form-fieldset v-bind:label="$t('STATUS')">
                            <inputvalidation :formerror="formError" name="status"><b-form-select :options="status"
                                    v-model="formData.status"></b-form-select></inputvalidation>
                        </b-form-fieldset>
                    </div>
                </div>
                <div class="form-row mb-lg">
                    <div class="col-sm-6" v-if="!newuser">
                        <b-form-fieldset v-bind:label="$t('USERGROUP')">
                            <inputvalidation :formerror="formError" name="groupId"><b-form-select :options="aclGroups.root"
                                    v-model="formData.groupId" value-field="groupId" text-field="groupName"></b-form-select>
                            </inputvalidation>
                        </b-form-fieldset>
                    </div>
                </div>
                <div class="form-row mb-lg">
                    <div class="col-sm-4 mb-2">
                        <strong>{{ $t('ADDITIONALDATA') }}</strong>
                    </div>
                </div>
                <div class="form-row mb-lg">
                    <div class="col-sm-3">
                        <b-form-fieldset v-bind:label="$t('NAME')">
                            <inputvalidation :formerror="formError" name="name"><b-form-input type="text"
                                    v-model="formData.name" v-bind:placeholder="$t('NAME')"></b-form-input>
                            </inputvalidation>
                        </b-form-fieldset>
                    </div>
                    <div class="col-sm-3">
                        <b-form-fieldset v-bind:label="$t('SURNAME')">
                            <inputvalidation :formerror="formError" name="surname"><b-form-input type="text"
                                    v-model="formData.surname" v-bind:placeholder="$t('SURNAME')"></b-form-input>
                            </inputvalidation>
                        </b-form-fieldset>
                    </div>
                    <div class="col-sm-3">
                        <b-form-fieldset v-bind:label="$t('OIBNUM')">
                            <inputvalidation :formerror="formError" name="oibNum"><b-form-input type="text"
                                    v-model="formData.oibNum" v-bind:placeholder="$t('OIBNUM')"></b-form-input>
                            </inputvalidation>
                        </b-form-fieldset>
                    </div>
                    <div class="col-sm-3">
                        <b-form-fieldset v-bind:label="$t('VISITQUOTA')">
                            <inputvalidation :formerror="formError" name="visitQuota"><b-form-input type="text" v-model="formData.visitQuota" v-bind:placeholder="$t('VISITQUOTA')"></b-form-input>
                            </inputvalidation>
                        </b-form-fieldset>
                    </div>
                </div>
                <div class="form-row mb-lg">
                    <div class="col-sm-3">
                        <b-form-fieldset v-bind:label="$t('TITLE')">
                            <inputvalidation :formerror="formError" name="title"><b-form-input type="text"
                                    v-model="formData.title" v-bind:placeholder="$t('TITLE')"></b-form-input>
                            </inputvalidation>
                        </b-form-fieldset>
                    </div>
                    <div class="col-sm-3">
                        <b-form-fieldset v-bind:label="$t('PHONE')">
                            <inputvalidation :formerror="formError" name="phone"><b-form-input type="text"
                                    v-model="formData.phone" v-bind:placeholder="$t('PHONE')"></b-form-input>
                            </inputvalidation>
                        </b-form-fieldset>
                    </div>
                    <div class="col-sm-3">
                        <b-form-fieldset v-bind:label="$t('USERCOLOR')">
                            <b-form-input v-model="formData.userColor" type="color"></b-form-input>
                        </b-form-fieldset>
                    </div>
                    <div class="col-sm-3">
                        <b-form-fieldset v-bind:label="$t('COMPANY')">
                            <inputvalidation :formerror="formError" name="companyId">
                                <lb-vue-select v-model="formData.companyId" :list="company.root" display-field="companyName"
                                    value-field="companyId">
                                </lb-vue-select>
                            </inputvalidation>
                        </b-form-fieldset>
                    </div>
                </div>
                <div class="form-row mb-lg">
                    <div class="col-sm-3">
                        <b-form-fieldset v-bind:label="$t('ADDRESS')">
                            <inputvalidation :formerror="formError" name="address"><b-form-input type="text"
                                    v-model="formData.address" v-bind:placeholder="$t('ADDRESS')"></b-form-input>
                            </inputvalidation>
                        </b-form-fieldset>
                    </div>
                    <div class="col-sm-3">
                        <b-form-fieldset v-bind:label="$t('CITY')">
                            <inputvalidation :formerror="formError" name="city"><b-form-input type="text"
                                    v-model="formData.city" v-bind:placeholder="$t('CITY')"></b-form-input>
                            </inputvalidation>
                        </b-form-fieldset>
                    </div>
                    <div class="col-sm-3">
                        <b-form-fieldset v-bind:label="$t('POSTALCODE')">
                            <inputvalidation :formerror="formError" name="postalCode"><b-form-input type="text"
                                    v-model="formData.postalCode" v-bind:placeholder="$t('POSTALCODE')"></b-form-input>
                            </inputvalidation>
                        </b-form-fieldset>
                    </div>
                    <div class="col-sm-3">
                        <b-form-fieldset v-bind:label="$t('COUNTRY')">
                            <inputvalidation :formerror="formError" name="country"><b-form-input type="text"
                                    v-model="formData.country" v-bind:placeholder="$t('COUNTRY')"></b-form-input>
                            </inputvalidation>
                        </b-form-fieldset>
                    </div>
                </div>
            </div>

            <div class="text-right">
                <b-btn class="mr-2 button-cancel" @click="close()">{{ $t('CLOSE') }}</b-btn>
                <b-btn class="button-save" @click="submitData(formData)">{{ $t('SAVE') }}</b-btn>
            </div>
        </div>
    </b-modal>
</template>

<script>
import {
    mapGetters,
}
    from 'vuex';
import Api from '@/api/admin/Users';
import CompanyApi from '@/api/admin/UserCompanies';
import AclGroupsApi from '@/api/admin/AclGroups';

export default
    {
        name: 'UsersForm',
        props: ['value'],
        data() {
            const me = this;

            return {
                formError: {},
                aclGroups: {},
                company: {},
                newuser: true,
                formData: null,
                status:
                    [
                        {
                            value: 'active',
                            text: me.$i18n.t('ACTIVE'),
                        },
                        {
                            value: 'inactive',
                            text: me.$i18n.t('INACTIVE'),
                        },
                    ],
            };
        },
        methods:
        {
            getAclGroups() {
                const me = this;
                AclGroupsApi.selectRow(me.getGroupParams, (data) => {
                    if (data.error && data.error === true) {
                        me.$notify.notice(data);
                        return;
                    }
                    me.aclGroups = data;
                });
            },
            async getUserCompany() {
                const me = this;
                try {
                    const data = await CompanyApi.selectRow();

                    if (data.error && data.error === true) {
                        throw (data);
                    }

                    data.root.unshift({ companyId: null, companyName: 'None' });

                    me.company = data;
                }
                catch (error) {
                    me.$notify.notice(error);
                }
            },
            async submitData(item) {
                const me = this;
                try {
                    if (typeof item.userId !== 'undefined') {
                        item.id = item.userId;
                        delete (item.userId);
                    }

                    const data = await Api.save(item);
                    me.$notify.notice(data);

                    if (data.error) {
                        me.formError = data;
                    }
                    else {
                        me.close();
                    }
                }
                catch (e) {
                    console.log(e);
                    me.$notify.notice(e);
                }
            },
            close() {
                const me = this;
                me.formError = {};
                me.formData = null;
                me.$emit('close');
            },
        },
        watch:
        {
            async formData(val) {
                const me = this;
                if (val != null) {
                    if (typeof val.userId !== 'undefined') {
                        me.newuser = false;
                    }
                    await me.getAclGroups();
                    await me.getUserCompany();
                    me.$refs.modal.show();
                }
                else {
                    me.$refs.modal.hide();
                }
            },
            value(val) {
                const me = this;
                if (val != null) {
                    me.formData = { ...val };
                }
                else {
                    me.formData = null;
                }
            },
        },
        computed:
        {
            ...mapGetters([
                'globals',
            ]),
        },
    };
</script>
